globalThis.Uploader = (function() {
    var defaults = {
        containers : {
            button : '.upload-image-container'
        },
        progress : {
            percent     : '.image-percent',
            progressbar : '.image-progressbar'
        },
        dropZone : {
            mainContainer : 'item-drop-zone',
            textContainer : 'item-drop-zone-text'
        },
        removeFile: '.remove-file',
        plupload  : {
            runtimes : 'html5,flash,silverlight',
            max_file_size    : '50mb',
            browse_button    : 'upload-image',
            headers: {
              'X-CSRF-Token': $.rails.csrfToken()
            },
            filters   : {
                mime_types : [
                    { title : 'Images', extensions : 'jpg,jpeg,png,webp' }
                ]
            },
            url : ''
        },
        data : {},
        autoUpload : true,
        callbacks  : {
            uploadComplete : function() {},
            removingFile: function() {}
        }
    }

    function Uploader(container, options, library) {
        this.config = $.extend(true, {}, defaults, options);;
        this.module = 'Uploader';
        this.view   = $(container);
        if(library) {
            this.library = library;
        }
        this.button = this.view.find(this.config.containers.button);
        this.init();
    }

    Uploader.prototype = {
        init : function() {
            utils.require([assets.plupload], function() {
              this.setData(this.config.data);
              this.view.data('uploader-initialized', true);
              this.uploader = new plupload.Uploader(this.config.plupload);
              this.initDropZone();
              this.events();
            }.bind(this));
        },
        events : function() {
            var that = this;
            this.uploader.init();
            this.uploader.bind('FilesAdded', function(up, files) {
                if(that.dropZone) that._hideDropZone();
                that.config.callbacks.filesAdded.call(that, up, files);
                if(that.config.autoUpload) this.start();
                //setTimeout(function() { me.start(); }, 200);
            });
            this.uploader.bind('UploadProgress', function(up, file) {
                that.config.callbacks.uploadProgress.call(that, up, file);
            });
            this.uploader.bind('FileUploaded', function(up, file, response) {
                var response = JSON.parse(response.response);
                that.config.callbacks.fileUploaded.call(that, up, file, response);
            });
            this.uploader.bind('UploadComplete', function(uploader, files) {
                that.config.callbacks.uploadComplete.call(that, uploader, files);
            });
            this.uploader.bind('Error', function(uploader, error) {
              that.config.callbacks.error.call(that, uploader, error);
            });
            // Drag and Drop events
            if(this.dropZone) {
                this.view[0].addEventListener('dragenter', function(e) {
                    that._showDropZone('Déposez ici...')
                });
                this.view[0].addEventListener('dragleave', function(e) {
                    if(e.pageX == 0) {
                        that._hideDropZone();
                    }
                });
                this.dropZoneContainer[0].addEventListener('dragenter', function(e) {
                    e.stopImmediatePropagation();
                    that._showDropZone('Vous pouvez lâcher !');
                });
                window.addEventListener('dragover', function(e) {
                    e.preventDefault();
                },false);
                window.addEventListener('drop', function(e) {
                    e.preventDefault();
                    that._hideDropZone();
                },false);
            }
            this.view.on('click', this.config.removeFile, function() {
              that.config.callbacks.removingFile.call(that, that.uploader, $(this));
            });
        },
        upload : function(callback) {
            if(!this.uploadErrors) {
                if(typeof callback == 'function') this.config.callbacks.uploadComplete = callback;
                this.uploader.start();
            }
        },
        initDropZone : function() {
            this.dropZoneContainer = $(this.config.plupload.drop_element);
            if(this.dropZoneContainer.length) {
                var text = ""
                if (DeviceQueries.isTactilDevice()) {
                    text = 'Aucun fichier ajouté'
                } else {
                    text = 'Déposez vos fichiers ici...'
                }
                this.dropZone = $('<div id="' + this.config.dropZone.mainContainer + '">' +
                    '<div id="' + this.config.dropZone.textContainer + '">' +
                    text +
                    '</div>' +
                    '</div>'
                ).appendTo(this.dropZoneContainer);
            }
        },
        hasFiles : function() {
            return this.uploader.files.length > 0;
        },
        setData : function(data) {
            if(typeof data == 'object') {
                if(this.uploader) {
                    this.uploader.settings.multipart_params = $.extend({}, this.uploader.settings.multipart_params, data);
                } else {
                    this.config.plupload.multipart_params = $.extend({}, this.config.data, data);
                }
            }
        },
        _showDropZone : function(text) {
            this.dropZone.show();
            if(text) this._changeDropZoneText(text);
        },
        _hideDropZone : function() {
            this.dropZone.hide();
        },
        _changeDropZoneText : function(text) {
            this.dropZone.find('#' + this.config.dropZone.textContainer).text(text);
        },
        log : function(msg) {
            return this.module + ': ' + msg;
        }
    }

    return Uploader;
})();
